import React, {Component} from "react";
import {applyRouterMiddleware, browserHistory, Route, Router} from "react-router";
import {useScroll} from "react-router-scroll";
import Pricing from "./modules/views/Pricing";
import BotProduct from "./modules/views/bot/Product";
import Register from "./modules/views/Register";
import Login from "./modules/views/Login";
import Dashboard from "./modules/views/Dashboard";
import Subscription from "./modules/views/Subscription";
import Actions from "./modules/views/bot/Actions";
import Connections from "./modules/views/bot/Connections";
import Builds from "./modules/views/bot/Builds";
import Logs from "./modules/views/Logs";
import Account from "./modules/views/Account";
import Terms from "./modules/views/legal/Terms";
import EULA from "./modules/views/legal/EULA";
import Privacy from "./modules/views/legal/Privacy";
import Docs from "./modules/views/docs/Index";
import DocsBotFAQ from "./modules/views/docs/bot/FAQ";
import DocsBotActions from "./modules/views/docs/bot/Actions";
import DocsBotActionSecurity from "./modules/views/docs/bot/ActionSecurity";
import DocsBotConnections from "./modules/views/docs/bot/Connections";
import DocsPlatform from "./modules/views/docs/Platform";
import Samples from "./modules/views/docs/bot/Samples";
import DocsBotBuildSystems from "./modules/views/docs/bot/BuildSystems";
import DocsBotGettingStarted from "./modules/views/docs/bot/GettingStarted";
import About from "./modules/views/docs/about/About";
import Contact from "./modules/views/docs/about/Contact";
import Subscribe from "./modules/views/Subscribe";

class BotApp extends Component {
    logPageView = () => this.props.logPageView();
    requireAuth = (nextState, replace) => this.props.requireAuth(nextState, replace);

    render() {
        return (
            <Router history={browserHistory}
                    render={applyRouterMiddleware(useScroll())}
                    onUpdate={this.logPageView}>

                {/* Unauthenticated marketing */}
                <Route path="/" component={BotProduct}/>
                <Route path="/pricing" component={Pricing}/>

                {/* Auth */}
                <Route path="/register" component={Register}/>
                <Route path="/login" component={Login}/>

                {/* Legal */}
                <Route path="/legal/terms" component={Terms}/>
                <Route path="/legal/license" component={EULA}/>
                <Route path="/legal/privacy" component={Privacy}/>

                {/* Docs */}
                <Route path="/docs" component={Docs}/>
                <Route path="/docs/platform" component={DocsPlatform}/>

                {/* Bot docs */}
                <Route path="/docs/bot/faq" component={DocsBotFAQ}/>
                <Route path="/docs/bot/actions" component={DocsBotActions}/>
                <Route path="/docs/bot/action-security" component={DocsBotActionSecurity}/>
                <Route path="/docs/bot/build-systems" component={DocsBotBuildSystems}/>
                <Route path="/docs/bot/connections" component={DocsBotConnections}/>
                <Route path="/docs/bot/getting-started" component={DocsBotGettingStarted}/>
                <Route path="/docs/bot/samples" component={Samples}/>

                {/* About docs */}
                <Route path="/docs/about" component={About}/>
                <Route path="/docs/about/contact" component={Contact}/>

                {/* Common authenticated */}
                <Route path="/dashboard" component={Dashboard} onEnter={this.requireAuth}/>
                <Route path="/subscription" component={Subscription} onEnter={this.requireAuth}/>
                <Route path="/subscribe" component={Subscribe} onEnter={this.requireAuth}/>
                <Route path="/logs" component={Logs} onEnter={this.requireAuth}/>
                <Route path="/account" component={Account} onEnter={this.requireAuth}/>

                {/* Bot */}
                <Route path="/bot/builds" component={Builds} onEnter={this.requireAuth}/>
                <Route path="/bot/actions" component={Actions} onEnter={this.requireAuth}/>
                <Route path="/bot/connections" component={Connections} onEnter={this.requireAuth}/>

                {/* Legacy links */}
                <Route path="/bot" onEnter={() => document.location.href = '/'}/>
                <Route path="/mocks" onEnter={() => document.location.href = 'https://www.mocks.cloud'}/>
            </Router>
        );
    }
}

BotApp.propTypes = {
    logPageView: React.PropTypes.func.isRequired,
    requireAuth: React.PropTypes.func.isRequired,
};

export default BotApp;



// WEBPACK FOOTER //
// ./src/BotApp.js